import http from "../../http"
import {API_V1_URL} from "../../constants/other"


const PURCHASE_REQUESTS_URL = `${API_V1_URL}/purchase-requests/`

export const getUserPurchases = (params) => http.get(`${PURCHASE_REQUESTS_URL}`, {params})
